import type { BlogsCollectionItem } from "@nuxt/content";
import type { RouteLocationNormalized } from "vue-router";

function updateHeroFromFrontMatter($io: IOStore, page: BlogsCollectionItem) {

  const hero = page?.hero
  const contentSlug = "blog"
  if(!hero) return;

  if (hero?.media) {
    const type = "image" // hero.media.type // we can use video when we can accept the full shape of the videom settings
    const payload = {
      src: hero.media.media.src ? 
        '/images/' + contentSlug + '/' + page.slug + '/' + hero.media.media.src 
        : '/droplets-splash-1.jpg',
      alt: hero.media.media.alt ? hero.media.media.alt : page.slug,
    }
    $io.assignHeroMedia(type, payload)
  }
  if (hero?.content) {

    const payload: Partial<DynamicPageHeroSettings["content"]["content"]> = {
      title: hero.content.content.title || "",
      hairline: hero.content.content.hairline || "",
      description: hero.content.content.description || "",
    }
    if(hero.content.content.tags) {
      payload.tags = hero.content.content.tags
    }
    if(hero.content.content.line) {
      payload.line = hero.content.content.line
    }
    if(hero.content.content.lineColor) {  
      payload.lineColor = hero.content.content.lineColor
    }

    $io.assignHeroContent('page', payload)
  }

  // if(hero?.overlays) {
  //   // overlay:
  //   // type: "gradient"
  //   // options:
  //   //   direction: "to bottom"
  //   //   colors: ["purple", "gold"]
  //   //   opacity: 0.8

  //   $io.assignHeroOverlays([
  //     {
  //       type: hero.overlay.type,
  //       options: {
  //         direction: hero.overlay.options.direction,
  //         colors: hero.overlay.options.colors,
  //       }
  //     }
  //   ])
  // }

  // This ensures we give the hero a unique id
  $io.hero.key = page.slug;

  // if (hero?.overlay) {
  //   $io.assignHeroOverlay(hero.overlay)
  // }

  // if (hero?.media) {
  //   // later provide video support
  //   const payload = {
  //     type: 'image',
  //     src: hero.media.media.src ? '/images/blog/' + blogSlug.value + '/' + hero.media.media.src : '/custom-solutions.jpg',
  //     alt: hero.media.media.alt ? hero.media.media.alt : postTitle.value,
  //   }

  //   console.log("payload", payload)
  //   $io.assignHeroMedia(payload)
  // }
}

function getSlugAsString(route: RouteLocationNormalized) {
  if (!route.params || typeof route.params !== 'object' || !('slug' in route.params)) {
    return '';
  }
  
  const slugParam = route.params.slug;
  if (!slugParam) return '';
  return Array.isArray(slugParam) ? slugParam[0] : slugParam;
}

export default defineNuxtRouteMiddleware(async (to, from) => {

  // console.log("to", to) 
  // console.log("from", from)

  if (!to.path.startsWith('/blog/')) return
  const routeSlug = getSlugAsString(to)

  const { $io } = useNuxtApp()


  const { data: page } = await useAsyncData(
    `blog-${routeSlug}`,
    () => queryCollection('blogs')
      .where('slug', '=', routeSlug)
      .first()
  )

  if (page.value) {
    updateHeroFromFrontMatter($io, page.value)
  }


})